import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VFabTransition,[_c(VBtn,{class:_vm.marginTop,attrs:{"color":_vm.color ? _vm.color : _vm.getThemeColor,"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){return _vm.$emit('button-clicked')}}},[_c(VIcon,[_vm._v("mdi-plus")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }